module.exports = __webpack_public_path__ + "img/schroeder.cf99901c.jpg";